var map = {
	"./စက်ပစ္စည်းအမျိုးမျိုး.png": 6396,
	"./လက်သမားသုံးပစ္စည်းများ.png": 3274,
	"./လယ်ယာသုံးပစ္စည်း.png": 3179,
	"./အိမ်ဆောက်ပစ္စည်း.png": 9218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9721;